import { useEffect, type RefObject } from 'react';

/**
 * When `focusAt` changes, the element scrolls into view just below the
 * pinned tab bar — more than once, because the sections above it are
 * still loading and push it down as they arrive.
 */
export function useScrollFocus(ref: RefObject<HTMLElement | null>, focusAt?: number) {
  useEffect(() => {
    if (!focusAt) return;
    let last = -1, tries = 0;
    const settle = () => {
      const el = ref.current;
      if (!el) return;
      // The tab bar stays pinned near the top; land just below where it sits.
      const tabs = document.querySelector<HTMLElement>('.tabs');
      const bar = tabs ? tabs.offsetHeight + (parseFloat(getComputedStyle(tabs).top) || 0) : 0;
      const top = el.getBoundingClientRect().top + window.scrollY - bar - 4;
      if (top !== last) window.scrollTo({ top });
      last = top;
      if (++tries < 12) timer = window.setTimeout(settle, 150);
    };
    let timer = window.setTimeout(settle, 0);
    return () => window.clearTimeout(timer);
  }, [focusAt]);
}
